import React, {useEffect} from 'react'
import './OrderPendingModal.scss'
import {assetUrl} from "../../serviceApi";

const illustration = assetUrl+'images/Illustration_Order_execution.png'
const wrong_image = assetUrl+"images/wrong_image.svg";

const OrderPendingModal = (props) => {

	const {order_mode, checkStatus} = props

	useEffect(() => {

		if (order_mode !== "Limit_Order") {
			checkStatus()
			setInterval(() => {
				checkStatus()
			}, 5000)
			return () => {
				clearInterval()
			};
		}
		// else{
		// 	setTimeout(()=>{
		// 		window.location.reload()
		// 	},3000)
		// }

	}, []);

	return (
		<div className={"order-pending-main text-center"}>
			<img src={wrong_image} alt="Italian-Trulli" className="close-icon" onClick={() => props.closeModal()}/>
			<img src={illustration} alt={"alt"} className={"illustration"}/>
			<p className={"title mb-3"}>
				{
					order_mode !== "Limit_Order" ? "Your Order is being executed!" : "Thank you for placing the order!"
				}
			</p>
			<p className={"sub-text"}>
				{
					order_mode !== "Limit_Order" ?
						<>
							{/*<span>Please wait, we are working on </span>*/}
							{/*<br/>*/}
							<span>Feel free to close the window and continue trading.</span>
						</>
						: "Your order will be executed once the market price matches with your set price."
				}
			</p>
		</div>
	)
}

export default OrderPendingModal
